module.exports = __webpack_public_path__ + "img/canara.e268207d.png";